import styled from "styled-components";

export const Wrapper = styled.div`
  padding-left: 11px;
  ${({Label, theme})=>Label && `
	font-family: ${theme.fontFamily.helveticaNeue};
	font-size: ${theme.fontSize.primary};
	line-height: ${theme.lineHeight.primary};
	color: ${theme.fontColors.textColor};
  `}
  ${({ PaddingTopBottom }) =>
  PaddingTopBottom &&
	`
	padding-top: 50px;
	padding-left: 0px;
	padding-bottom: 50px;
  `}
  ${({ Input, theme }) =>
    Input &&
    `
		padding-left: 0px;
		width:115px;
		.ant-input{
		font-family: ${theme.fontFamily.helveticaNeue};
		font-size: ${theme.fontSize.primary};
		color: ${theme.fontColors.textColor};
		}
		@media only screen and (max-width: 990px) {
			padding-left: 0px;
			width:130px;
			height: 40px;
			>div >input {
				margin-top: 4px;
				height: 40px;
			}
		}
	`}
`;
